import { router } from "@inertiajs/react";
import { ButtonProps, LinkProps, Link as MuiLink } from "@mui/material";
import { useCallback, useMemo } from "react";

interface IProps extends LinkProps {
  button?: ButtonProps;
  href: string;
  hideIcons?: boolean;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  external?: boolean;
}

const Link: React.FC<IProps> = ({ children, href, onClick, sx, external }) => {
  const isExternalLink = useMemo(
    () => external || href.startsWith("http"),
    [external, href],
  );

  const handleNavigate = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      e.stopPropagation();

      onClick?.(e);

      router.visit(href);
    },
    [href, onClick],
  );

  return (
    <MuiLink
      sx={{
        textDecoration: "none",
        maxWidth: "400px",
        margin: "0px auto",
        borderBottom: "3px solid transparent",
        "&:hover": {
          borderBottom: (t) => `3px solid ${t.palette.primary.light}`,
        },
        ...sx,
      }}
      onClick={isExternalLink ? onClick : handleNavigate}
      href={href}
      rel="noopener noreferrer"
      target={isExternalLink ? "_blank" : "_self"}
    >
      {children}
    </MuiLink>
  );
};

export default Link;
